import './App.css';
import Navbar from './components/navbar-large-screen/Navbar';
import Home from './sections/Home';
import About from './sections/About';
import Skills from './sections/Skills';
import Projects from './sections/Projects';
import Footer from './components/footer/Footer';
import { scroller } from 'react-scroll';

function App() {

  const scrollToHome = () => {
    scroller.scrollTo('home', {
      duration: 1000,
      smooth: true,
    });
  };
  const scrollToAbout = () => {
    scroller.scrollTo('about', {
      duration: 1000,
      smooth: true,
    });
  };
  const scrollToSkills = () => {
    scroller.scrollTo('skills', {
      duration: 1000,
      smooth: true,
    });
  };
  const scrollToProjects = () => {
    scroller.scrollTo('projects', {
      duration: 1000,
      smooth: true,
    });
  };

  return (
    <div className="">
      <Navbar
        scrollToHome={scrollToHome}
        scrollToAbout={scrollToAbout}
        scrollToSkills={scrollToSkills}
        scrollToProjects={scrollToProjects}
      />
      <Home />
      <About />
      <Skills />
      <Projects />
      <Footer />
    </div>
  );
}

export default App;
